<template>
    <c-dialog ref="dialog" width="450" @resolve="editHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>
            <c-form-item label="节假日名称" required>
                <c-input name="holiday_name" maxlength="50"></c-input>
            </c-form-item>
            <c-form-item label="节假日类型" required :tip="holidayTypeWord">
                <c-select name="holiday_type" v-model="holiday_type" :options="holidayTypeDic" placeholder="请选择"></c-select>
            </c-form-item>
            <c-form-item label="开始日期" required >
                <c-datetime type="date" name="start_date"></c-datetime>
            </c-form-item>
            <c-form-item label="结束日期" required >
                <c-datetime type="date" name="end_date"></c-datetime>
            </c-form-item>
            <c-form-item label="备注">
                <c-input type="textarea" name="remark" maxlength="500"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
    computed: {
        ...mapState(['holidayTypeDic']),
        holidayTypeWord() {
            return {
                1: '国家法定节日，上班则收取3倍工资',
                2: '周末被调成上班，按正常工作日处理',
                4: '原工作日调整为休息日，按正常休息日处理'
            }[this.holiday_type]
        },
    },
    data() {
        return {
            holiday_type:1              //1=法定节假日(休息日)，2=调休工作日(需上班)'
        }
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this._editState = !!data;
            this.$refs.form.clear();
            if (data) {
                this.holiday_type  = data.holiday_type||1;
                this.$refs.form.set(data);
            }
            //填充form表单
            this.$refs.dialog.open({
                title: data ? '编辑节假日信息' : '编辑节假日信息'
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle (stop, next){
            stop();
            this.$refs.form.submit({
                url: this._editState?'/holiday/calendar/edit':'/holiday/calendar/add',
                rule: {
                    holiday_name: '请输入节假日名称',
                    holiday_type: '请输入节假日类型',
                    start_date: '请选择节假日开始日期',
                    end_date: '请选择节假日结束日期',
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '提交成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>